var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatusExpired = function SvgStatusExpired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.409,
    height: 25.409,
    viewBox: "0 0 25.409 25.409",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-expired{fill:#ff6b6b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-expired",
    d: "M259.705,111a12.7,12.7,0,1,0,12.7,12.7,12.72,12.72,0,0,0-12.7-12.7Zm0,24.169A11.465,11.465,0,1,1,271.169,123.7a11.478,11.478,0,0,1-11.464,11.465ZM260.6,118.5a.38.38,0,0,1,.108.275l-.251,7.858a.38.38,0,0,1-.38.37h-.743a.38.38,0,0,1-.38-.37l-.251-7.858a.38.38,0,0,1,.379-.389h1.246a.38.38,0,0,1,.272.115Zm.092,9.545v1.423a.38.38,0,0,1-.38.379H259.1a.38.38,0,0,1-.38-.379v-1.423a.381.381,0,0,1,.38-.38h1.212a.38.38,0,0,1,.38.38Zm.623,2.482",
    transform: "translate(-247 -111)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-expired.a5a272c6.svg";
export { ForwardRef as ReactComponent };